import tippy from 'tippy.js';
import Popups from '../../components/popups/popups';
import { MOBILE } from '../../assets/scripts/constants';

class TooltipButton {
	constructor(el) {
		this.mm = window.matchMedia(MOBILE);
		this.buttonTooltip = el;
		this.content = this.buttonTooltip?.getAttribute('data-tooltip-text');
		this.popupName = this.buttonTooltip?.getAttribute('data-tooltip-button');
		this.placementValue = this.buttonTooltip?.getAttribute('data-collection-placement');
		this.hasInteraction = this.buttonTooltip?.getAttribute('data-interactive') === 'true';

		if (this.buttonTooltip && this.content && this.popupName && !this.buttonTooltip.inited) {
			this.init();
		}
	}

	init() {
		this.buttonTooltip.inited = true;

		this.buttonTooltip.tippy = tippy(this.buttonTooltip, {
			content: this.content,
			offset: [0, 10],
			duration: [300, 200],
			allowHTML: true,
			placement: this.placementValue ? this.placementValue : 'top',
			interactive: this.hasInteraction,
			onShow: this.handleShow.bind(this),
		});
	}

	handleShow(instance) {
		if (!this.mm.matches) return;

		const button = instance.reference;
		button.addEventListener('click', () => Popups.open(this.popupName));
	}
}

document.querySelectorAll('[data-tooltip-button]').forEach((el) => new TooltipButton(el));

export default TooltipButton;
